/** 🔥 all type are based on this Enum */
export const WizardBasketDatas = {
  reports: 'reports',
  semantics: 'semantics',
  datamarts: 'datamarts',
  views: 'views',
  tables: 'tables',
} as const;
Object.freeze(WizardBasketDatas);

export type WizardBasketDataType = (typeof WizardBasketDatas)[keyof typeof WizardBasketDatas];
